import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-dataprotection',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './dataprotection.component.html',
  styleUrl: './dataprotection.component.scss'
})
export class DataprotectionComponent {

}
